"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merchantStatement = _interopRequireWildcard(require("@/api/merchantStatement"));
var statementApi = _merchantStatement;
var _EditStatementDetailDialog = _interopRequireDefault(require("./EditStatementDetailDialog"));
var _EditStatementOrderDialog = _interopRequireDefault(require("./EditStatementOrderDialog"));
var _row2 = _interopRequireDefault(require("element-ui/packages/row"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'StatementOrderDialog',
  components: {
    EditStatementDetailDialog: _EditStatementDetailDialog.default,
    EditStatementOrderDialog: _EditStatementOrderDialog.default
  },
  data: function data() {
    return {
      visible: false,
      statementRow: {},
      statementInfo: {},
      activeDetailTab: 'statement',
      crossMonthTimeRange: [],
      settledAfterSaleTimeEnd: '',
      searchForm: {
        detailType: '',
        transactionId: '',
        orderNo: '',
        createTimeRange: [],
        orderStatus: '',
        customerId: '',
        addedToStatement: ''
      },
      initTimeRange: [],
      customerOptions: [],
      pagination: {
        page: 1,
        limit: 20
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      batchAddLoading: false,
      batchRemoveLoading: false,
      reconciliationRemarkDialogVisible: false,
      financialRemarkDialogVisible: false,
      remarkForm: {
        detailId: null,
        reconciliationRemark: '',
        financialRemark: ''
      },
      remarkLoading: false,
      remarkPopover: {
        visible: false,
        title: '',
        content: ''
      }
    };
  },
  computed: {
    row: function row() {
      return _row2.default;
    },
    dialogTitle: function dialogTitle() {
      return "\u8D26\u5355\u660E\u7EC6 - ".concat(this.statementInfo.statementNo || '');
    },
    isChecked: function isChecked() {
      return this.statementInfo.reconciliationStatus === 1;
    }
  },
  methods: {
    open: function open(row, statementInfo) {
      this.visible = true;
      this.statementRow = row;
      this.statementInfo = statementInfo || {};
      var pd = statementInfo && statementInfo.periodDesc ? statementInfo.periodDesc : '';
      var parts = pd.split(' 至 ');
      var periodStart = parts[0];
      var periodEnd = parts[1];
      this.initTimeRange = periodStart && periodEnd ? [periodStart, periodEnd] : [];
      var previousMonthFirstTime = this.getPreviousMonthFirstTime(periodStart);
      this.crossMonthTimeRange = previousMonthFirstTime && periodStart ? [previousMonthFirstTime, periodStart] : [];
      this.settledAfterSaleTimeEnd = periodStart || '';
      this.resetSearch();
      this.searchForm.createTimeRange = periodStart && periodEnd ? [periodStart, periodEnd] : [];
      this.fetchCustomerOptions();
      this.fetchList();
    },
    handleChange: function handleChange(val) {
      var initStart = this.initTimeRange[0] ? new Date(this.initTimeRange[0]).getTime() : null;
      var initEnd = this.initTimeRange[1] ? new Date(this.initTimeRange[1]).getTime() : null;
      var startTime = new Date(val[0]).getTime();
      var endTime = new Date(val[1]).getTime();
      if (initStart === null || initEnd === null) return;
      // if (startTime < initStart || endTime > initEnd) {
      //   this.$message.warning('所选时间范围不能超出账单周期时间范围，已重置账单周期时间');
      //   this.$nextTick(() => {
      //     this.searchForm.createTimeRange = [...this.initTimeRange];
      //   });
      //   return;
      // }
    },
    handleClosed: function handleClosed() {
      this.resetSearch();
      this.listData = {
        list: [],
        total: 0
      };
      this.statementRow = {};
      this.statementInfo = {};
      this.initTimeRange = [];
      this.crossMonthTimeRange = [];
      this.settledAfterSaleTimeEnd = '';
    },
    resetSearch: function resetSearch() {
      this.activeDetailTab = 'statement';
      this.searchForm.detailType = '';
      this.searchForm.createTimeRange = [];
      this.searchForm.transactionId = '';
      this.searchForm.orderNo = '';
      this.searchForm.orderStatus = '';
      this.searchForm.customerId = '';
      this.searchForm.addedToStatement = '';
      this.pagination.page = 1;
    },
    fetchCustomerOptions: function fetchCustomerOptions() {
      var _this = this;
      if (this.customerOptions.length > 0) return;
      (0, _merchantStatement.activeCustomersApi)().then(function (res) {
        _this.customerOptions = res || [];
      }).catch(function () {
        _this.customerOptions = [];
      });
    },
    handleSearch: function handleSearch() {
      this.pagination.page = 1;
      this.fetchList();
    },
    handleDetailTypeChange: function handleDetailTypeChange(tab) {
      var detailTypeMap = {
        statement: '',
        crossMonth: 3,
        settledAfterSale: 2
      };
      this.searchForm.detailType = detailTypeMap[tab.name];
      if (this.searchForm.detailType === '') {
        this.searchForm.createTimeRange = _toConsumableArray(this.initTimeRange);
      }
      this.pagination.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.resetSearch();
      this.searchForm.createTimeRange = _toConsumableArray(this.initTimeRange);
      this.pagination.page = 1;
      this.fetchList();
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.listLoading = true;
      var params = {
        statementId: this.statementRow.id,
        merchantId: this.statementRow.merchantId,
        page: this.pagination.page,
        limit: this.pagination.limit,
        detailType: this.searchForm.detailType,
        transactionId: this.searchForm.transactionId || undefined,
        orderNo: this.searchForm.orderNo || undefined,
        orderStatus: this.searchForm.orderStatus || undefined,
        customerId: this.searchForm.customerId || undefined,
        addedToStatement: this.searchForm.addedToStatement === '' ? undefined : this.searchForm.addedToStatement
      };
      if (this.searchForm.detailType === 3 && this.crossMonthTimeRange.length === 2) {
        params.createTimeStart = this.crossMonthTimeRange[0];
        params.createTimeEnd = this.crossMonthTimeRange[1];
      } else if (this.searchForm.detailType === 2 && this.settledAfterSaleTimeEnd) {
        params.createTimeEnd = this.settledAfterSaleTimeEnd;
      } else if (this.searchForm.detailType === '' && this.searchForm.createTimeRange && this.searchForm.createTimeRange.length === 2) {
        params.createTimeStart = this.searchForm.createTimeRange[0];
        params.createTimeEnd = this.searchForm.createTimeRange[1];
      }
      statementApi.statementOrderFilterListApi(params).then(function (res) {
        var list = res && res.list ? res.list : Array.isArray(res) ? res : [];
        list.forEach(function (item) {
          _this2.$set(item, '_loading', false);
        });
        _this2.listData = {
          list: list,
          total: res.total || list.length
        };
      }).catch(function () {
        _this2.listData = {
          list: [],
          total: 0
        };
      }).finally(function () {
        _this2.listLoading = false;
      });
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row;
      return row.addedToStatement ? 'row-added' : 'row-pending';
    },
    handleAddOne: function handleAddOne(row) {
      var _this3 = this;
      this.$confirm('确定将该订单添加至对账单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.$set(row, '_loading', true);
        statementApi.statementOrderAddApi({
          statementId: _this3.statementRow.id,
          orderId: row.orderId,
          detailType: _this3.searchForm.detailType
        }).then(function () {
          _this3.$message.success('添加成功');
          _this3.fetchList();
          _this3.$emit('refresh');
        }).catch(function (err) {
          _this3.$message.error(err.message || '添加失败');
        }).finally(function () {
          _this3.$set(row, '_loading', false);
        });
      }).catch(function () {});
    },
    handleRemoveOne: function handleRemoveOne(row) {
      var _this4 = this;
      if (!row.id) {
        this.$message.warning('该订单尚未加入对账单');
        return;
      }
      this.$confirm('确定从对账单中移除该订单吗？', '提示', {
        confirmButtonText: '确定移除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$set(row, '_loading', true);
        statementApi.statementOrderRemoveApi({
          statementId: _this4.statementRow.id,
          orderId: row.orderId,
          detailType: _this4.searchForm.detailType
        }).then(function () {
          _this4.$message.success('移除成功');
          _this4.fetchList();
          _this4.$emit('refresh');
        }).catch(function (err) {
          _this4.$message.error(err.message || '移除失败');
        }).finally(function () {
          _this4.$set(row, '_loading', false);
        });
      }).catch(function () {});
    },
    handleBatchAdd: function handleBatchAdd() {
      var _this5 = this;
      var params = {
        statementId: this.statementRow.id,
        merchantId: this.statementRow.merchantId,
        transactionId: this.searchForm.transactionId || undefined,
        orderNo: this.searchForm.orderNo || undefined,
        orderStatus: this.searchForm.orderStatus || undefined,
        customerId: this.searchForm.customerId || undefined,
        addedToStatement: false
      };
      if (this.searchForm.createTimeRange && this.searchForm.createTimeRange.length === 2) {
        params.createTimeStart = this.searchForm.createTimeRange[0];
        params.createTimeEnd = this.searchForm.createTimeRange[1];
      }
      this.$confirm('确定将当前筛选结果中所有未加入对账单的订单全部添加至对账单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.batchAddLoading = true;
        statementApi.statementOrderAddByFilterApi(params).then(function (res) {
          _this5.$message.success("\u6DFB\u52A0\u5B8C\u6210\uFF1A\u6210\u529F ".concat(res.successCount || 0, " \u6761\uFF0C\u5931\u8D25 ").concat(res.failCount || 0, " \u6761"));
          _this5.fetchList();
          _this5.$emit('refresh');
        }).catch(function (err) {
          _this5.$message.error(err.message || '添加失败');
        }).finally(function () {
          _this5.batchAddLoading = false;
        });
      }).catch(function () {});
    },
    handleBatchRemove: function handleBatchRemove() {
      var _this6 = this;
      var params = {
        statementId: this.statementRow.id,
        merchantId: this.statementRow.merchantId,
        transactionId: this.searchForm.transactionId || undefined,
        orderNo: this.searchForm.orderNo || undefined,
        orderStatus: this.searchForm.orderStatus || undefined,
        customerId: this.searchForm.customerId || undefined,
        addedToStatement: true
      };
      if (this.searchForm.createTimeRange && this.searchForm.createTimeRange.length === 2) {
        params.createTimeStart = this.searchForm.createTimeRange[0];
        params.createTimeEnd = this.searchForm.createTimeRange[1];
      }
      this.$confirm('确定将当前筛选结果中所有已加入对账单的订单全部从对账单中移除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.batchRemoveLoading = true;
        statementApi.statementOrderRemoveByFilterApi(params).then(function (res) {
          _this6.$message.success("\u79FB\u9664\u5B8C\u6210\uFF1A\u6210\u529F ".concat(res.successCount || 0, " \u6761\uFF0C\u5931\u8D25 ").concat(res.failCount || 0, " \u6761"));
          _this6.fetchList();
          _this6.$emit('refresh');
        }).catch(function (err) {
          _this6.$message.error(err.message || '移除失败');
        }).finally(function () {
          _this6.batchRemoveLoading = false;
        });
      }).catch(function () {});
    },
    handleReconciliationRemark: function handleReconciliationRemark(row) {
      this.remarkForm.detailId = row.id;
      this.remarkForm.reconciliationRemark = row.reconciliationRemark || '';
      this.remarkForm.financialRemark = '';
      this.reconciliationRemarkDialogVisible = true;
    },
    handleSaveReconciliationRemark: function handleSaveReconciliationRemark() {
      var _this7 = this;
      this.remarkLoading = true;
      statementApi.statementOrderDetailRemarkApi({
        detailId: this.remarkForm.detailId,
        reconciliationRemark: this.remarkForm.reconciliationRemark
      }).then(function () {
        _this7.$message.success('保存成功');
        _this7.reconciliationRemarkDialogVisible = false;
        _this7.fetchList();
      }).catch(function (err) {
        _this7.$message.error(err.message || '保存失败');
      }).finally(function () {
        _this7.remarkLoading = false;
      });
    },
    handleEditDetail: function handleEditDetail(row) {
      this.$refs.editStatementDetailDialog.open(row, this.statementRow.id);
    },
    handleEditOrder: function handleEditOrder(row) {
      this.$refs.editStatementOrderDialog.open(row, this.statementRow.id);
    },
    handleEditOrderRefresh: function handleEditOrderRefresh() {
      this.fetchList();
      this.$emit('refresh');
    },
    handleEditDetailRefresh: function handleEditDetailRefresh() {
      this.fetchList();
      this.$emit('refresh');
    },
    handleFinancialRemark: function handleFinancialRemark(row) {
      this.remarkForm.detailId = row.id;
      this.remarkForm.reconciliationRemark = '';
      this.remarkForm.financialRemark = row.financialRemark || '';
      this.financialRemarkDialogVisible = true;
    },
    handleSaveFinancialRemark: function handleSaveFinancialRemark() {
      var _this8 = this;
      this.remarkLoading = true;
      statementApi.statementOrderDetailRemarkApi({
        detailId: this.remarkForm.detailId,
        financialRemark: this.remarkForm.financialRemark
      }).then(function () {
        _this8.$message.success('保存成功');
        _this8.financialRemarkDialogVisible = false;
        _this8.fetchList();
      }).catch(function (err) {
        _this8.$message.error(err.message || '保存失败');
      }).finally(function () {
        _this8.remarkLoading = false;
      });
    },
    handleOrderDetail: function handleOrderDetail(row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          orderNo: row.orderNo
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1;
      this.fetchList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchList();
    },
    formatAmount: function formatAmount(val) {
      return val != null ? Number(val).toFixed(2) : '0.00';
    },
    formatActualSettlementAmount: function formatActualSettlementAmount(row) {
      var actualSettlementAmount = Number(row.actualSettlementAmount || 0);
      var actualSettlementFreight = Number(row.actualSettlementFreight || 0);
      var actualSettlementPackingFee = Number(row.actualSettlementPackingFee || 0);
      return this.formatAmount(actualSettlementAmount + actualSettlementFreight + actualSettlementPackingFee);
    },
    hasAmount: function hasAmount(val) {
      if (val === '' || val === null || val === undefined) return false;
      var amount = Number(val);
      return !isNaN(amount) && amount !== 0;
    },
    formatCreateTime: function formatCreateTime(val) {
      return val ? val.replace('T', ' ') : '-';
    },
    getPreviousMonthFirstTime: function getPreviousMonthFirstTime(periodStart) {
      var match = periodStart && periodStart.match(/^(\d{4})-(\d{2})/);
      if (!match) return '';
      var year = Number(match[1]);
      var month = Number(match[2]);
      var previousYear = month === 1 ? year - 1 : year;
      var previousMonth = month === 1 ? 12 : month - 1;
      return "".concat(previousYear, "-").concat(String(previousMonth).padStart(2, '0'), "-01 00:00:00");
    },
    getCustomerName: function getCustomerName(customerId) {
      if (!customerId) return '-';
      var item = this.customerOptions.find(function (opt) {
        return opt.id === customerId;
      });
      return item ? item.name : '-';
    },
    merchantTypeText: function merchantTypeText(val) {
      var map = {
        1: '卡券供应商',
        2: '实物供应商',
        3: '家政供应商',
        4: '核销供应商'
      };
      return map[val] || '-';
    },
    orderStatusText: function orderStatusText(val) {
      var map = {
        0: '已取消',
        1: '待支付',
        2: '已支付',
        3: '处理中',
        16: '部分发货',
        4: '已发货',
        5: '已签收',
        6: '已完结',
        71: '待退款',
        7: '退款中',
        8: '退款成功',
        9: '退款失败',
        10: '拒绝退款',
        11: '已关闭',
        12: '支付失败',
        13: '向第三方下单失败',
        14: '部分退款',
        15: '售后中'
      };
      return map[val] || val || '-';
    },
    orderStatusType: function orderStatusType(val) {
      var map = {
        0: 'info',
        // 已取消
        1: 'warning',
        // 待支付
        2: 'success',
        // 已支付
        3: 'warning',
        // 处理中
        4: 'success',
        // 已发货
        5: 'success',
        // 已签收
        6: 'success',
        // 已完结
        7: 'warning',
        // 退款中
        8: 'success',
        // 退款成功
        9: 'danger',
        // 退款失败
        10: 'danger',
        // 拒绝退款
        11: 'info',
        // 已关闭
        12: 'danger',
        // 支付失败
        13: 'danger',
        // 向第三方下单失败
        14: 'warning',
        // 部分退款
        15: 'warning',
        // 售后中
        16: 'warning',
        // 部分发货
        71: 'warning' // 待退款
      };
      return map[val] || 'info';
    },
    showRemarkPopover: function showRemarkPopover(event, content, title) {
      this.remarkPopover.title = title;
      this.remarkPopover.content = content;
      this.remarkPopover.visible = true;
    }
  }
};